<template>
  <BLayoutList
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
    :create-route="createRoute"
  >
    <BTableCommon
      v-model="selected"
      type="notification-pages"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:edit="onActionEdit"
      @action:view="onActionView"
      @action:new-tab="onOpenNewTab"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { NotificationPageModel as Model } from './Model'
import { notificationPagesStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import { NOTIFICATION_PAGES_ROUTES as ROUTES } from './utils'
import { LK_NOTIFICATION_PAGES_ROUTES } from '@/views/LKNotificationPages/utils'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)


/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'HelpPagesList',
  components: {
    BLayoutList,
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      return { name: ROUTES.CREATE }
    },
  },
  methods: {
    onActionEdit(data) {
      this.$router.push({
        name: ROUTES.EDIT,
        params: {
          id: data.id,
        },
      })
    },
    onActionView(data) {
      this.$router.push({
        name: ROUTES.VIEW,
        params: {
          id: data.id,
        },
      })
    },
    onOpenNewTab(data) {
      const routeData = this.$router.resolve({ name: LK_NOTIFICATION_PAGES_ROUTES.VIEW, params: { url: data.url } })
      window.open(decodeURIComponent(routeData.href), '_blank')
    },
  },
}
</script>
